<!-- <div class="row bg-danger border-danger w-100" *ngIf="util.isLocalhost()"> -->
<!-- You are on localhost!!! -->
<!-- </div> -->
<div class="img-cloud" [ngClass]="{'border-warning-top': util.isLocalhost()}">
  <div class="mx-2" style="min-height: 90vh">
    <header></header>
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>